import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Typography } from '@components/Typography';
import { InternalLink } from '@components/Link';
import WidgetRecommendations from './WidgetRecommendations';

const Container = styled(Paper)({
    padding: 24,
    '@media (max-width: 1024px)': {
        padding: 16,
    },
    '&:not(:last-child)': {
        marginBottom: 16,
    },
});

const Header = styled('div')({
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    '& > svg path': {
        fill: 'var(--primary-main)',
        fillOpacity: 1,
    },
});

const TitleBlock = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    flex: 1,
    minWidth: 0,
});

const SectionWrapper = ({
    children,
    withLink = true,
    icon: Icon,
    text,
    subtitle,
    url,
    recommendationTypes,
    ...rest
}) => {
    return (
        <Container {...rest}>
            <div>
                <Header>
                    <Icon width={24} height={24} style={{ flexShrink: 0, marginTop: 1 }} />
                    <TitleBlock>
                        <Typography variant="subtitle2">{text}</Typography>
                        {subtitle ? (
                            <Typography variant="caption" sx={{ color: 'var(--text-secondary)', display: 'block' }}>
                                {subtitle}
                            </Typography>
                        ) : null}
                    </TitleBlock>
                    {withLink && (
                        <InternalLink to={url} underline="none" sx={{ marginLeft: 'auto', height: '18px' }}>
                            <IconButton sx={{ height: 24, width: 24 }} color="inherit">
                                <ArrowForwardIcon sx={{ color: 'var(--primary-main)', height: 18, width: 18 }} />
                            </IconButton>
                        </InternalLink>
                    )}
                </Header>
                <div style={{ backgroundColor: 'var(--divider)', margin: '16px 0', height: '1px' }} />
            </div>
            {children}
            {recommendationTypes && recommendationTypes.length > 0 ? (
                <WidgetRecommendations types={recommendationTypes} />
            ) : null}
        </Container>
    );
};

export default SectionWrapper;
